import { topicList } from "@/mocks/news";

export default function TrendingTopics() {
  const badge = (t: "up" | "down" | "new") =>
    t === "up"
      ? { icon: "ri-arrow-up-line", cls: "bg-primary-100 text-primary-600", label: "上升中" }
      : t === "down"
        ? { icon: "ri-arrow-down-line", cls: "bg-secondary-100 text-secondary-600", label: "回落" }
        : { icon: "ri-sparkling-2-fill", cls: "bg-accent-100 text-accent-700", label: "新上榜" };

  return (
    <section id="topics" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
            <i className="ri-chat-3-fill" />
            Trending
          </span>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            热议话题热榜
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-700">
            正在被全网热烈讨论的焦点话题，点击话题查看对应最新内容。
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topicList.map((topic, i) => {
            const b = badge(topic.trend);
            return (
              <button
                key={topic.id}
                type="button"
                onClick={() => document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" })}
                className="group flex items-center justify-between gap-3 rounded-2xl border border-background-200 bg-background-50 p-5 text-left transition-all hover:-translate-y-1 hover:border-secondary-300 hover:shadow-card md:p-6"
              >
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-background-100 font-heading text-lg font-black text-primary-500 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="text-base font-bold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-lg">
                      {topic.name}
                    </h3>
                    <p className="mt-1 flex items-center gap-1 text-xs text-foreground-600">
                      <i className="ri-fire-line text-primary-500" />
                      讨论量 {topic.count}
                    </p>
                  </div>
                </div>
                <span className={`flex shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${b.cls}`}>
                  <i className={b.icon} />
                  {b.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}